/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { PaginatedReviewAdmin } from './PaginatedReviewAdmin'
import {
  PaginatedReviewAdminFromJSON,
  PaginatedReviewAdminFromJSONTyped,
  PaginatedReviewAdminToJSON,
} from './PaginatedReviewAdmin'

/**
 *
 * @export
 * @interface EnvelopedReviewListReviewAdmin
 */
export interface EnvelopedReviewListReviewAdmin {
  /**
   *
   * @type {PaginatedReviewAdmin}
   * @memberof EnvelopedReviewListReviewAdmin
   */
  body: PaginatedReviewAdmin
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedReviewListReviewAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedReviewListReviewAdmin interface.
 */
export function instanceOfEnvelopedReviewListReviewAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedReviewListReviewAdminFromJSON(
  json: any,
): EnvelopedReviewListReviewAdmin {
  return EnvelopedReviewListReviewAdminFromJSONTyped(json, false)
}

export function EnvelopedReviewListReviewAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedReviewListReviewAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: PaginatedReviewAdminFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedReviewListReviewAdminToJSON(
  value?: EnvelopedReviewListReviewAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: PaginatedReviewAdminToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
